import { render, staticRenderFns } from "./sedeField.vue?vue&type=template&id=648529cc&scoped=true&"
import script from "./sedeField.vue?vue&type=script&lang=js&"
export * from "./sedeField.vue?vue&type=script&lang=js&"
import style0 from "./sedeField.vue?vue&type=style&index=0&id=648529cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648529cc",
  null
  
)

export default component.exports